import React from "react";
import { Modal, Button, Header } from "semantic-ui-react";

const PrintLabelConfirmationModal = ({
  open,
  cancelCallback,
  continueCallback,
  cancelOldLabel,
  isMachineNotControlled,
}) => {
  let message = cancelOldLabel
    ? "Makulera denna sändning och skriv ut en ny etikett"
    : isMachineNotControlled
    ? "Skriv ut kopia?"
    : "Skriv ut en till etikett?";
  return (
    <Modal open={open} onClose={cancelCallback} size="small">
      <Header icon="warning sign" color="red" content={"Bekräfta!"} />
      <Modal.Content>
        <h1>{message}</h1>
      </Modal.Content>
      <Modal.Actions>
        <Button secondary onClick={cancelCallback}>
          NEJ
        </Button>
        <Button primary onClick={continueCallback}>
          JA
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default PrintLabelConfirmationModal;
